import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "pending-container"
}
const _hoisted_3 = {
  key: 0,
  class: "iconn-button_text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: $props.id,
    class: _normalizeClass(["iconn-button", $setup.iconnClasses]),
    onClick: $setup.handleClick
  }, [
    ($props.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "skeleton-label iconn-skeleton",
          style: _normalizeStyle($setup.calculateTextWidth)
        }, null, 4 /* STYLE */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($props.pending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "pending" }, null, -1 /* HOISTED */)
              ])))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "left", {}, () => [
            ($props.iconLeft)
              ? (_openBlock(), _createBlock($setup["IconMaterial"], {
                  key: 0,
                  icon: $props.iconLeft,
                  variant: $props.iconLeftVariant,
                  color: $props.iconLeftColor,
                  size: $setup.iconLeftSizeValue,
                  disabled: $props.disabled,
                  onClick: _withModifiers($setup.clickLeftIconHandler, ["stop"])
                }, null, 8 /* PROPS */, ["icon", "variant", "color", "size", "disabled"]))
              : _createCommentVNode("v-if", true)
          ], true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            ($props.text)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.text), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], true),
          _renderSlot(_ctx.$slots, "right", {}, () => [
            ($props.iconRight)
              ? (_openBlock(), _createBlock($setup["IconMaterial"], {
                  key: 0,
                  icon: $props.iconRight,
                  variant: $props.iconRightVariant,
                  color: $props.iconRightColor,
                  size: $setup.iconRightSizeValue,
                  disabled: $props.disabled,
                  onClick: _withModifiers($setup.clickRightIconHandler, ["stop"])
                }, null, 8 /* PROPS */, ["icon", "variant", "color", "size", "disabled"]))
              : _createCommentVNode("v-if", true)
          ], true)
        ], 64 /* STABLE_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}